import api from "~/store/api"
import serialize from "~/store/serialize"

export const listCategories = (data) => {
  return api
    .get("/categories", data)
    .then((res) => serialize("category", res.data.data))
}

export const updateCategoryOrder = (data) => {
  return api.post("/categories/order", data).then((res) => res?.data)
}

export const fetchCategory = (id) => {
  return api
    .get(`/categories/${id}`)
    .then((res) => serialize("category", res.data.data))
}

export const createCategory = (data) => {
  return api.post("/categories", data).then((res) => res.data)
}

export const updateCategory = (id, data) => {
  return api.put(`/categories/${id}`, data).then((res) => res.data)
}

export const deleteCategory = (id, data) => {
  return api.delete(`/categories/${id}`, data).then((res) => res.data)
}
export const listArticles = (data) => {
  return api.get("/articles", data).then((res) => res.data.data)
}

export const createArticle = (data) => {
  return api.post("/articles", data).then((res) => res.data)
}

export const updateArticle = (id, data) => {
  return api.put(`/article/${id}`, data).then((res) => res.data)
}

export const deleteArticle = (id, data) => {
  return api.delete(`/article/${id}`, data).then((res) => res.data)
}
